import ImageOptimizer from '@/components/image-optimizer';
import {
  convertRouteFromBoardType,
  slugify,
  storyArticleListPathSegment,
} from '@/lib/utils';
import { ArticleEntity } from '@/services/types/article.type';
import ArrowDetailSvg from '@/svg/detail-arrow.svg';
import Link from 'next/link';

export default function ArticleHeader({
  id,
  title,
  thumbPath,
  // viewDatetime,
  subTitle,
  board,
}: ArticleEntity) {
  return (
    <Link
      href={
        convertRouteFromBoardType(board) +
        '/' +
        storyArticleListPathSegment(board.type) +
        '/' +
        slugify(title, id)
      }
      className="block transition"
    >
      <div className="desktop:flex-row desktop:items-center desktop:gap-10 flex flex-col gap-4">
        <div className="flex gap-4">
          <div className="desktop:h-[320px] relative aspect-[27/16] w-full overflow-hidden rounded-lg">
            <ImageOptimizer
              src={thumbPath}
              alt={title}
              fill
              className="object-cover"
              // sizes="(max-width: 768px) 100px, 120px"
            />
          </div>
        </div>
        <div className="fle-col desktop:flex desktop:h-full desktop:grow desktop:flex-col desktop:justify-between">
          <div className="text-level-5 typo-18 desktop:typo-24 desktop:mb-5 mb-4 font-semibold">
            {/* {formatKoreanDate(viewDatetime)} */}
          </div>
          <div className="desktop:h-full">
            <div className="text-level-2 typo-28 desktop:typo-36 desktop:mb-8 mb-6 line-clamp-1 font-extrabold">
              {title}
            </div>
            <div className="text-level-3 typo-20 desktop:typo-26 desktop:leading-snug desktop:min-h-[68px] line-clamp-2 leading-snug font-semibold">
              {subTitle}
            </div>
            <div className="desktop:flex mt-14 hidden items-center gap-2">
              <span className="text-level-5 typo-20 font-semibold">
                자세히보기
              </span>
              <ArrowDetailSvg />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
